import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../common/EzToast";
import EzNotFound from "../../common/EzNotFound";
import { Box, Container } from "@mui/material";
import Breadcrumb from "../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import { APP_URLS } from "../../utils/constant";
import { printTableData } from "../../utils/printUtils";
const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const Location = (props) => {
  const classes = useStyles();
  const [areFiltersVisible, toggleFilterState] = useState(true);
  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const {
    fetchLocations,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportLocation,
    isLocationExportError,
    isLocationExportSuccess,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateLocation,
    editLocationRoute,
    deleteLocation,
    shouldOpenDeleteConfirmationPopup,
    isLocationDeleteSuccess,
    isLocationDeleteError,
    copyLocationRoute,
    savedTableState,
    onTableStateChange,
  } = props;
  const breadcrumbD = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/location", label: "Location" },
  ];

  const convertToTSV = (data) => {
    const headers = data.columns.map((item) => item.colLabel).join("\t");
    const rows = data.rows
      .map((row) => {
        const { id, ...rowWithoutId } = row;
        return Object.values(rowWithoutId).join("\t");
      })
      .join("\n");
    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);

  useEffect(() => {
    if (isPrintError) {
      setTimeout(() => setIsPrintError(false), 3000);
    }
  }, [isPrintError]);

  const handlePrint = () => {
    const success = printTableData({
      title: 'Location',
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
      excludeColumns: ['id'],
      orientation: 'landscape'
    });

    if (!success) {
      setIsPrintError(true);
    }
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Location</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {screenPermissions?.create && (
                <Button
                  label={"Create Location"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateLocation}
                />
              )}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportLocation}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();

  // Build initial filters from saved state if available
  const getInitialFilters = () => {
    const defaultFilters = {
      global: { value: null },
      locationId: { value: null, filterKey: "locationId" },
      locationName: { value: null, filterKey: "locationName" },
      address: { value: null, filterKey: "address" },
      afterHourFee: { value: null, filterKey: "afterHourFee" },
      airportCode: { value: null, filterKey: "airportCode" },
      airportConcessionFeeRate: {
        value: null,
        filterKey: "airportConcessionFeeRate",
      },
      airportFacilityCharge: { value: null, filterKey: "airportFacilityCharge" },
      airportFacilityChargeMaxDays: {
        value: null,
        filterKey: "airportFacilityChargeMaxDays",
      },
      city: { value: null, filterKey: "city" },
      country: { value: null, filterKey: "country" },
      contact: { value: null, filterKey: "contact" },
      crtTime: { value: null, filterKey: "crtTime" },
      currencyCode: { value: null, filterKey: "currencyCode" },
      modTime: { value: null, filterKey: "modTime" },
      pin: { value: null, filterKey: "pin" },
      province: { value: null, filterKey: "province" },
      resPrefix: { value: null, filterKey: "resPrefix" },
      status: { value: null, filterKey: "status" },
      tax: { value: null, filterKey: "tax" },
      underageRate: { value: null, filterKey: "underageRate" },
      username: { value: null, filterKey: "username" },
      workingHourStartEnd: { value: null, filterKey: "workingHourStartEnd" },
      gmapLink: { value: null, filterKey: "gmapLink" },
    };

    // If we have saved filters, merge them with defaults
    if (savedTableState?.filters) {
      const savedFilters = savedTableState.filters;
      Object.keys(savedFilters).forEach(key => {
        if (defaultFilters[key]) {
          defaultFilters[key] = { ...defaultFilters[key], ...savedFilters[key] };
        }
      });
    }

    return defaultFilters;
  };

  const filters = getInitialFilters();
  const getToastProps = () => {
    if (isLocationDeleteSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Location deleted successfully!",
        shouldShowToast: true,
      };
    }
    if (isLocationDeleteError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while deleting Location!",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Data copied to clipboard!",
        shouldShowToast: true,
      };
    }

    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Please allow popups to use the print feature.",
        shouldShowToast: true,
      };
    }

    return {};
  };

  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Location found.",
    filters,
    loadLazyData: fetchLocations,
    loading: isLoading,
    showMoreActions: false,
    sortField: savedTableState?.sortField || 'id',
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    onTableStateChange,
    setDeleteConfirmationPopupVisibility,
    onEditRecord: editLocationRoute,
    onCopyRecord: copyLocationRoute,
    showViewButton: false,
    shouldOpenDeleteConfirmationPopup,
    onDeleteRecord: deleteLocation,
    showCopyButton: true,
    showDeleteButton: true,
    showEditButton: true,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={breadcrumbD} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box>
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Location records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default Location;
